import Component from './ManageUpsells';

export default Component;
